import React, { useState } from 'react';
import { FaronexoLogo } from './FaronexoLogo.jsx';
import { Button } from '@/components/ui/button';
import { Moon, Sun } from 'lucide-react';

export function LogoShowcase() {
  const [isDark, setIsDark] = useState(false);

  const bgClass = isDark ? 'bg-[#0a0a0a] text-white' : 'bg-white text-slate-900';
  const cardBgClass = isDark ? 'bg-slate-900 border-slate-800' : 'bg-slate-50 border-slate-200';

  return (
    <div className={`min-h-screen p-8 md:p-16 transition-colors duration-300 ${bgClass}`}>
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center justify-between mb-12 border-b border-current pb-6 opacity-80">
          <div>
            <h1 className="text-3xl font-bold mb-2">Brand Guidelines</h1>
            <p className="opacity-70">Faronexo Logo System</p>
          </div>
          <Button 
            variant="outline" 
            size="icon"
            onClick={() => setIsDark(!isDark)}
            className={isDark ? 'border-slate-700 hover:bg-slate-800 text-white' : ''}
          >
            {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Full Logo */}
          <div className={`p-12 rounded-2xl border flex flex-col items-center justify-center gap-8 ${cardBgClass}`}>
            <FaronexoLogo variant="full" size={48} />
            <div className="text-sm font-medium opacity-50 uppercase tracking-widest">Full Logo (Primary)</div>
          </div>

          {/* Icon Only */}
          <div className={`p-12 rounded-2xl border flex flex-col items-center justify-center gap-8 ${cardBgClass}`}>
            <FaronexoLogo variant="icon" size={64} />
            <div className="text-sm font-medium opacity-50 uppercase tracking-widest">Icon Only (Avatar/Favicon)</div>
          </div>

          {/* Monochromatic Full */}
          <div className={`p-12 rounded-2xl border flex flex-col items-center justify-center gap-8 ${cardBgClass}`}>
            <FaronexoLogo variant="mono" size={48} />
            <div className="text-sm font-medium opacity-50 uppercase tracking-widest">Monochromatic Full</div>
          </div>

          {/* Monochromatic Icon */}
          <div className={`p-12 rounded-2xl border flex flex-col items-center justify-center gap-8 ${cardBgClass}`}>
            <FaronexoLogo variant="icon" className="text-current [&_circle]:fill-current [&_path[stroke='#f59e0b']]:stroke-current" size={64} />
            <div className="text-sm font-medium opacity-50 uppercase tracking-widest">Monochromatic Icon</div>
          </div>
        </div>
        
        <div className="mt-16">
          <h2 className="text-xl font-semibold mb-6">Usage Notes</h2>
          <ul className="list-disc list-inside space-y-3 opacity-80">
            <li>The primary logo should be used in most contexts, especially in headers and marketing materials.</li>
            <li>The icon-only variant is reserved for constrained spaces like avatars, favicons, or mobile app icons.</li>
            <li>Monochromatic versions should be used when color printing is not available or when placing the logo over busy photography.</li>
            <li>Always ensure sufficient contrast between the logo and its background.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default LogoShowcase;